export const SNACKBAR_ERRORS = {
  FILE_NOT_VALID_ERROR: 'FILE_NOT_VALID_ERROR',
  UNSUPORTED_VIDEO_ERROR: 'UNSUPORTED_VIDEO_ERROR',
  WRONG_VIDEO_WIDTH_ERROR: 'WRONG_VIDEO_WIDTH_ERROR',
  WRONG_VIDEO_POSITION_ERROR: 'WRONG_VIDEO_POSITION_ERROR',
};

export const UPLOAD_STATUS = {
  UNSELECTED_FILE: 'unselected_file',
  UPLOADING: 'uploading',
  POLLING: 'polling',
  ERROR_POLLING: 'error_polling',
  ERROR_UPLOADING: 'error_uploading',
  SUCCESS: 'success',
};

export const VIDEO_UPLOADING_ACTIONS = {
  CLOSE_SNACK_BAR: 'closeSnackBar',
  SET_SNACK_BAR_ERROR: 'setSnackBarError',
  SET_SHOULD_RETRIEVE_STATUS: 'setShouldRetrieveStatus',
  SET_CURRENT_UPLOAD_STATUS: 'setCurrentUploadStatus',
  SET_FILE: 'setFile',
  POLLING: 'polling',
  UPLOAD_ERROR: 'uploadError',
  POLLING_ERROR: 'pollingError',
  POLLING_SUCCESS: 'pollingSuccess',
};
